export const TOOLTIP_CONTENT_SELECTOR = '.js__tooltip-content';
export const TOOLTIP_CONTENT_ACTIVE_CLASS = 'is-active';
export const TOOLTIP_HIDE_TIMEOUT = 500;